import { render, staticRenderFns } from "./Certificates.vue?vue&type=template&id=5ae6aa8e"
import script from "./Certificates.vue?vue&type=script&lang=ts"
export * from "./Certificates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports